export const BRAND = 'RowCentral';
export const DEMO_EMAIL = 'rowingcentralwebapp@gmail.com';
export const LEGAL_ENTITY = 'Barn Management Software LLC';

export const NAV_LINKS = [
  { href: '#roles', label: 'Who it\u2019s for' },
  { href: '#features', label: 'Features' },
  { href: '#mobile', label: 'Mobile' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#faq', label: 'FAQ' },
];

// Easing used across every landing animation so motion feels like one system.
export const EASE = [0.22, 1, 0.36, 1];
